"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildSafeCreateTransactionRequest = void 0;
const tslib_1 = require("tslib");
const ethers_1 = require("ethers");
const types_1 = require("../types");
const constants_1 = require("../constants");
const utils_1 = require("./utils");
function createSafeCreateSignature(signer, chainId, paymentToken, payment, paymentReceiver) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const domain = {
            name: constants_1.SAFE_FACTORY_NAME,
            chainId: ethers_1.BigNumber.from(chainId).toHexString(),
            verifyingContract: constants_1.SAFE_FACTORY_ADDRESS,
        };
        const types = {
            CreateProxy: [
                { name: "paymentToken", type: "address" },
                { name: "payment", type: "uint256" },
                { name: "paymentReceiver", type: "address" },
            ],
        };
        const values = {
            paymentToken,
            payment: ethers_1.BigNumber.from(payment),
            paymentReceiver,
        };
        return signer._signTypedData(domain, types, values);
    });
}
function buildSafeCreateTransactionRequest(signer, args) {
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        const sig = yield createSafeCreateSignature(signer, args.chainId, args.paymentToken, args.payment, args.paymentReceiver);
        const sigParams = {
            paymentToken: args.paymentToken,
            payment: args.payment,
            paymentReceiver: args.paymentReceiver,
        };
        const safeAddress = utils_1.deriveSafe(args.from);
        const request = {
            from: args.from,
            to: constants_1.SAFE_FACTORY_ADDRESS,
            // Note: obviously the safe here does not exist yet but useful to have this data in the db
            proxyWallet: safeAddress,
            data: "0x",
            signature: sig,
            signatureParams: sigParams,
            type: types_1.TransactionType.SAFE_CREATE,
        };
        console.log(`Created a SAFE-CREATE Transaction:`);
        console.log(request);
        return request;
    });
}
exports.buildSafeCreateTransactionRequest = buildSafeCreateTransactionRequest;
